// This file defines color mappings for different inspection categories

export interface CategoryColorConfig {
    color: string;
    label: string;
  }
  
  export const CATEGORY_COLORS: Record<string, CategoryColorConfig> = {
    // Using consistent naming with your API
    "Panen": { color: "#e74c3c", label: "Panen" },
    "Rawat": { color: "#2ecc71", label: "Rawat" },
    "Pupuk": { color: "#FF8C00", label: "Pupuk" }, // Orange
    "Patroli/Security": { color: "#9b59b6", label: "Patroli/Security" }, // Purple
    "Traksi": { color: "#3498db", label: "Traksi" }, // Blue
    "Infrastruktur & Sipil": { color: "#00bcd4", label: "Infrastruktur & Sipil" }, // Cyan
    "HPT/R&D": { color: "#FFD700", label: "HPT/R&D" }, // Amber/Gold
    "Mutu Ancak": { color: "#E67E22", label: "Mutu Ancak" }, //  Oranye tua terang
    "Mutu Buah": { color: "#1ABC9C", label: "Mutu Buah" }, //  Toska cerah
    "PMKS": { color: "#C0392B", label: "PMKS" }, //  Marun
    "Administrasi & Umum": { color: "#7F8C8D", label: "Administrasi & Umum" }, // Abu-abu modern
  };
  
  // Default color when category doesn't match
  export const DEFAULT_CATEGORY_COLOR = "#95a5a6"; // Gray
  
  /**
   * Get color for an inspection category
   * @param category Category name from the API
   * @returns Color hex code
   */
  export const getCategoryColor = (category?: string): string => {
    if (!category) return DEFAULT_CATEGORY_COLOR;
    
    // First try direct match
    if (CATEGORY_COLORS[category]) {
      return CATEGORY_COLORS[category].color;
    }
    
    // Try case-insensitive match
    const lowerCategory = category.toLowerCase();
    const matchingKey = Object.keys(CATEGORY_COLORS).find(
      key => key.toLowerCase() === lowerCategory
    );
    
    if (matchingKey) {
      return CATEGORY_COLORS[matchingKey].color;
    }
    
    return DEFAULT_CATEGORY_COLOR;
  };
  
  /**
   * Get all category colors for legend display
   * @returns Array of category color configurations
   */
  export const getAllCategoryColors = (): Array<CategoryColorConfig & { key: string }> => {
    return Object.entries(CATEGORY_COLORS).map(([key, config]) => ({
      key,
      ...config
    }));
  };